export const APP_NAME = 'ゆるボードゲームタイマー';
export const AUTHOR_NAME = 'Remin';

export const ROOM_LIFETIME_MS = 24 * 60 * 60 * 1000; // 1日
